export default "__VITE_PUBLIC_ASSET__19ebf9c0__"